const STORAGE_KEY = "pfs_login_return_to";

export function saveLoginReturnTo(path: string): void {
  try {
    sessionStorage.setItem(STORAGE_KEY, path);
  } catch (e) {
    console.warn("[LoginReturnTo] Failed to save to sessionStorage:", e);
  }
}

export function getLoginReturnTo(): string | null {
  try {
    return sessionStorage.getItem(STORAGE_KEY);
  } catch (e) {
    console.warn("[LoginReturnTo] Failed to read from sessionStorage:", e);
    return null;
  }
}

export function clearLoginReturnTo(): void {
  try {
    sessionStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    console.warn("[LoginReturnTo] Failed to clear sessionStorage:", e);
  }
}
